import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { resetScroll } from "./utilities";
import { spellScrollStateKey } from "./spellPage";

import "./index.css"


export default function SpellHtmlContent({ html }) {
    const ref = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const handleClick = (e) => {
            // Only intercept left-clicks on <a>
            const a = e.target.closest("a");
            if (!a) return;

            if (
                e.button !== 0 ||         // not left click
                e.metaKey || e.ctrlKey || e.shiftKey || e.altKey
            ) {
                return; // let browser handle new tab/window
            }

            const href = a.getAttribute("href");
            if (!href) return;

            // detect external: http(s):, mailto:, tel:, //...
            const isExternal = /^[a-zA-Z][a-zA-Z\d+\-.]*:|^\/\//.test(href);
            if (!isExternal) {
                e.preventDefault();
                resetScroll(spellScrollStateKey(href), true);
                navigate(`/spells/${href}`, { relative: false });
            }
            // external links will work normally
        };

        el.addEventListener("click", handleClick);
        return () => el.removeEventListener("click", handleClick);
    }, [navigate]);

    return <div className="spell-description" ref={ref} dangerouslySetInnerHTML={{ __html: html }} />;
}
